import { render, staticRenderFns } from "./revenue-chart.vue?vue&type=template&id=4186ee2c&scoped=true&"
import script from "./revenue-chart.vue?vue&type=script&lang=js&"
export * from "./revenue-chart.vue?vue&type=script&lang=js&"
import style0 from "./revenue-chart.vue?vue&type=style&index=0&id=4186ee2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186ee2c",
  null
  
)

export default component.exports